import * as React from "react";

import * as PropTypes from "../prop-types";
import { Draggable } from "react-beautiful-dnd";
import { SpsButton } from "../button/SpsButton";
import { ButtonKind, SpsIcon } from "@spscommerce/ds-shared";
import { I18nContext } from "../i18n";

const propsDoc = {
    index: "number",
    key: "string",
    columnId: "string",
    name: "string",
    value: "string",
    onDelete: "(columnValue: string) => void",
    mandatory: "boolean",
};

const propTypes = {
    ...PropTypes.spsGlobalPropTypes,
    index: PropTypes.number,
    key: PropTypes.string,
    columnId: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    onDelete: PropTypes.fun<(columnValue: string) => void>(),
    mandatory: PropTypes.bool,
};

export type SpsColumnChooserColumnProps = PropTypes.InferTS<typeof propTypes, HTMLDivElement>;

export function SpsColumnChooserColumn(props: SpsColumnChooserColumnProps) {
    const { index, key, columnId, name, value, onDelete, mandatory, ...rest } = props;
    const { t } = React.useContext(I18nContext);
    return (
        <Draggable key={columnId} draggableId={columnId} index={index || 0} {...rest}>
            {(provided, _snapshot) => (
                <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="sps-content-row"
                >
                    <div className="sps-content-row__col-group" data-col-value={value}>
                        <div className="sps-content-row__col sps-column-chooser__grab-col">
                            <i className="sps-column-chooser__drag-handle" />
                        </div>
                        <div className="sps-content-row__col--borderless">
                            <div className="sps-body-12">{name}</div>
                        </div>
                        <div className="sps-content-row__col sps-column-chooser__delete-col">
                            {!mandatory && (
                                <SpsButton
                                    aria-label={t("design-system:columnChooser.removeButton", {
                                        elementName: name,
                                    })}
                                    kind={ButtonKind.ICON}
                                    icon={SpsIcon.X}
                                    onClick={(): void => {
                                        if (onDelete) {
                                            onDelete(value);
                                        }
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </Draggable>
    );
}

Object.assign(SpsColumnChooserColumn, {
    props: propsDoc,
    propTypes,
    displayName: "SpsColumnChooserColumn",
});
